import React from 'react';
import { observer ,inject} from 'mobx-react';

@inject('ganttStore')
@observer
export default class TaskInfo extends React.Component<{ganttStore},any>{
    render(){
        const {ganttStore}=this.props;
        const {taskInfo}=ganttStore;
        return <div className="taskInfo" style={{left:taskInfo.left,top:taskInfo.top}}>
            {taskInfo.show&&<div className="taskContent">
            <div>{taskInfo.text1}</div>
            <div>{taskInfo.text2}</div>
            </div>}
        </div>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/gantt/TaskInfo.tsx